import { Outlet, useLocation, useNavigate } from "react-router-dom";
import React, { createContext, useEffect, useState, useContext } from "react";
import { Box, Button, Container } from "@mui/material";
import QMentisBreadCrumb from "../../custom-components/QMentisBreadCrumb";
import DownloadIcon from "@mui/icons-material/Download";
import { Typography } from "@mui/material";
import { ReactComponent as AutomateIcon } from "../../../images/automateIcon.svg";
import FullscreenToggle from "../../custom-components/FullScreenToggle";
import ApiDetailsPage from "../../output-components/api-testing/ApiDetails.js";
import TestCasesforApiTesting from "../../output-components/api-testing/TestCasesforApiTesting.js";
import APIConfiguration from "../../output-components/api-testing/APIConfiguration.js";
import ChooseTestCase from "../../output-components/api-testing/ChooseTestCase.js";
import IntroduceSCHEMA from "../../output-components/api-testing/IntroduceSCHEMA.js";
import FeatureFile from "../../output-components/api-testing/FeatureFileAPI.js";
import POJOclasses from "../../output-components/api-testing/POJOclasses.js";
import APIStepDefinition from "../../output-components/api-testing/APIStepDefinition.js";

function ApiTestingOutputPage() {
  const location = useLocation();
  const navigate = useNavigate();

  const [apiDetails, setApiDetails] = useState({});
  const [testCasesapi, setTestCaseAPI] = useState([]);
  const [ConfigData, setConfigData] = useState({});
   const [selectedTestCase, setselectedTestCase] = useState({});
  // const [featureFile, setfeatureFile] = useState("");
  // const [pojoClass, setPojoClass] = useState("");
  // const [payloadSchema, setPayloadSchema] = useState({});
  // const [stepDefinition, setStepDefinition] = useState("");
  // const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    
    setTestCaseAPI(location.state?.generateTestCasesData || []);
    setConfigData(location.state?.configurationData || {});
    setselectedTestCase(location.state?.selectedTestCaseData || {});
    // setfeatureFile(location.state?.featureFileData || "");
    // setPojoClass(location.state?.pojoData || "");
    // setStepDefinition(location.state?.stepDefinitionData || "");
  }, [
    location.state?.generateTestCasesData,
    location.state?.configurationData,
    location.state?.selectedTestCaseData,
    // location.state?.featureFileData,
    // location.state?.pojoData,
    // location.state?.stepDefinitionData,
  ]);


  const breadCrumbs = [
    {
      title: "API Details",
      status: testCasesapi.length > 0 ? "Completed" : "In Progress",
    },
    {
      title: "Test Cases",
      status:
        testCasesapi.length === 0
          ? "Not Started"
          : testCasesapi.length === 0 && Object.entries(ConfigData).length === 0
            ? "In Progress"
            : testCasesapi.length > 0
              ? "Completed"
              : "Not Started",
    },
    // {
    //   title: "Configuration",
    //   status:
    //     Object.keys(ConfigData).length === 0
    //       ? "Not Started"
    //       : ConfigData.APIFramework === "" && testCasesapi.length > 0 && Object.entries(ConfigData).length > 0 
    //         ? "In Progress"
    //         : ConfigData.APIFramework !== "" && testCasesapi.length > 0 && Object.entries(ConfigData).length > 0
    //           ? "Completed"
    //           : "In Progress",
    // },
    // {
    //   title: "Choose Test Cases",
    //   status:
    //     (Object.keys(selectedTestCase).length > 0 && testCasesapi.length > 0)
    //       ? "Completed"
    //       : (ConfigData.APIFramework && testCasesapi.length > 0)
    //         ? "In Progress"
    //         : "Not Started",
    // },
    // {
    //   title: "Feature File",
    //   status:
    //     Object.keys(selectedTestCase).length > 0 && featureFile !== "" 
    //       ? "Completed"
    //       : featureFile === "" && Object.keys(selectedTestCase).length > 0
    //         ? "In Progress"
    //         : featureFile === "" && Object.keys(selectedTestCase).length === 0
    //           ? "Not Started"
    //           : "Not Started",
    // },
    // {
    //   title: "Introduce SCHEMA",
    //   status:
    //     pojoClass !== ""
    //       ? "Completed"
    //       : pojoClass === "" && featureFile !== "" && confirmed
    //         ? "In Progress"
    //         : "Not Started",
    // },
    // {
    //   title: "POJO Classes",
    //   status:
    //     pojoClass !== "" 
    //       ? "Completed"
    //       : pojoClass === ""  
    //         ? "Not Started"
    //         : "Not Started",
    // },
    // {
    //   title: "Step Definition",
    //   status:
    //     stepDefinition !== ""
    //       ? "Completed"
    //       : stepDefinition === "" && pojoClass !== ""
    //         ? "Not Started"
    //         : "Not Started",
    // },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        flexGrow: 1,
        zIndex: 999999999,
      }}
    >
      <Box sx={{ maxHeight: "100%", width: "100%" }}>
        {/* Fixed breadcrumb where you want it */}
        <Box
          sx={{
            position: "sticky",
            top: "0",
            width: "100%", // Adjust width when sidebar expands
            zIndex: 1000,
            bgcolor: "white",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            overflow: "hidden",
            padding: "0 8px",
            transition: "width 0.3s ease-in-out", // Smooth transition effect
          }}
        >
          <QMentisBreadCrumb
            breadCrumbs={breadCrumbs}
            sx={{
              height: "auto",
              minHeight: "68px",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              overflow: "hidden",
              wordBreak: "break-word",
              textOverflow: "ellipsis",
              flexShrink: 1,
              width: "100%",
              maxWidth: "100%",
              transition: "max-width 0.3s ease-in-out", // Adjust when sidebar expands
            }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            bgcolor: "#f6f3f2",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            overflowY: "auto",
            width: "100%",
            height: "80vh",
            minHeight: "80vh",
            position: "relative",
            WebkitOverflowScrolling: "touch",
            scrollbarWidth: "thin",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#888",
              borderRadius: "4px",
              minHeight: "20px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#555",
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              // maxWidth: "600px",
              maxWidth: {
                xs: "100%",
                sm: "95vw",
                md: "1100px",
                lg: "1100px",
              },
              margin: "10px auto",
              paddingBottom: "3vh",
              "& > *:not(:last-child)": {
                marginBottom: "16px", // Adds margin between components but not after the last one
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
              mb={0.1}
            >
              <Box display="flex" alignItems="center" mb={0.1}>
                <AutomateIcon style={{ marginRight: 4 }} />
                <Typography
                  variant="body2"
                  color="text.secondary"
                  gutterBottom
                  sx={{ mt: 0.5 }}
                >
                  Generate comprehensive test cases with API details
                </Typography>
              </Box>
              <FullscreenToggle />
            </Box>

            {/* Rendering of all the files based on conditions */}

            {Object.entries(apiDetails).length === 0 && (
              <ApiDetailsPage
                generateTestCasesData={testCasesapi}
                setTestCaseAPI={setTestCaseAPI}
              />
            )}
            {testCasesapi.length > 0 && (
              <TestCasesforApiTesting
                generateTestCasesData={testCasesapi}
                setTestCaseAPI={setTestCaseAPI}
                setConfigData={setConfigData}
              />
            )}
            <Outlet />
            {/* 
            {Object.entries(ConfigData).length > 0 && (
              <APIConfiguration configurationData={ConfigData} />
            )}

            {Object.entries(ConfigData).length > 0 &&
              ConfigData.APIFramework !== "" && (
                <ChooseTestCase
                  generateTestCasesData={testCasesapi}
                  setTestCaseAPI={setTestCaseAPI}
                />
              )}
            {Object.entries(featureFile).length > 0 && (
              <FeatureFile
                featureFileData={featureFile}
                setfeatureFile={setfeatureFile}
                confirmed={confirmed}
                setConfirmed={setConfirmed}
              />
            )}
            {(pojoClass !== "" || confirmed) && (
              <IntroduceSCHEMA pojoClass={pojoClass} confirmed = {confirmed}/>
            )}
            {/* {confirmed && <IntroduceSCHEMA confirmed={confirmed} />} 

            {pojoClass !== "" && (
              <POJOclasses
                pojoData={pojoClass}
                setPojoData={setPojoClass}
                featureFileData={featureFile}
              />
            )}
            {stepDefinition !== "" && (
              <APIStepDefinition
                stepDefinitionData={stepDefinition}
                setStepDefinitionData={setStepDefinition}
                pojoClassData={pojoClass}
                featureFileData={featureFile}
              />
            )} */}

            {/* <TestCasesforApiTesting/> */}
            {/* <ChooseTestCase/>
                        <IntroduceSCHEMA/>
                        <FeatureFile/> */}
          </Box>
        </Box>
      </Box>
      <Box
        component="footer"
        sx={{
          width: "100%",
          maxWidth: "601px",
          backgroundColor: "#f6f3f2",
          textAlign: "center",
          paddingX: "5px",
          position: "fixed",
          bottom: "0",
          zIndex: "99",
        }}
      >
        <Typography variant="caption" color="textSecondary">
          Use QMentisAI™ with human supervision, as with all generative AI
          tools.
        </Typography>
      </Box>
    </Box>
  );
}

export default ApiTestingOutputPage;
